import React from "react";
import { Button } from "./ui/button";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "./ui/table";
import { useParams, useNavigate } from "react-router";
import uuid from "react-uuid";
import _ from "lodash";

import useFiringActions from "../hooks/useFiringActions";
import useSegmentActions from "../hooks/useSegmentActions";
import Modal from "../Modal";
import FiringGraph from "./FiringGraph";
import useFirebaseFiring from "../hooks/useFirebaseFiring";
import useFirebaseSegments from "../hooks/useFirebaseSegments";
import useFirebaseProject from "../hooks/useFirebaseProject";

const FiringFavouriteCopyConfirmPage = () => {
  const { project_id, firing_id } = useParams();
  const navigate = useNavigate();
  const project = useFirebaseProject(project_id!);
  const firing = useFirebaseFiring(firing_id!);
  const segments = useFirebaseSegments();
  const my_segments = _.filter(segments, (segment) => segment.firing_id === firing_id);
  const sorted_segments_array = Object.values(my_segments).sort((a, b) => {
    return a.order - b.order;
  });

  const { createFiring } = useFiringActions();
  const { createSegment } = useSegmentActions();

  const copyFavourite = (destination_project_id: any) => {
    const my_firing = { ...firing };
    my_firing.favourite = false;
    const new_id = uuid();
    my_firing.id = new_id;
    my_firing.project_id = destination_project_id;
    my_segments.forEach((segment) => {
      const new_segment = { ...segment };
      new_segment.id = uuid();
      new_segment.firing_id = new_id;
      createSegment(new_segment, false);
    });

    createFiring(my_firing, true);
  };

  const renderContent = () => (
    <div className="flex gap-4">
      <div className="w-[37.5%]">
        <FiringGraph sortedSegments={sorted_segments_array} showAnnotations={false} degrees={null} project={null} />
      </div>
      <div className="w-[62.5%]">
        {" "}
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Rate</TableHead>
              <TableHead>Temperature</TableHead>
              <TableHead>Hold</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sorted_segments_array.map((segment, index) => (
              <TableRow key={segment.id}>
                <TableCell>{segment.name}</TableCell>
                <TableCell>{segment.rate}</TableCell>
                <TableCell>{segment.temperature}</TableCell>
                <TableCell>{segment.hold}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
  const actions = () => (
    <>
      {" "}
      <Button
        variant="outline"
        disabled={my_segments.length === 0}
        onClick={() => {
          if (segments && (segments as any).length !== 0) {
            copyFavourite(project_id);
          }
        }}
      >
        Confirm
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </>
  );

  if (!project || !firing || !my_segments) {
    return <div>Loading...</div>;
  }
  return (
    <Modal
      onDismiss={() => navigate(-1)}
      title={"Copy Firing:" + firing.name}
      actions={actions()}
      content={renderContent()}
    />
  );
};

export default FiringFavouriteCopyConfirmPage;
